<mat-form-field class="relative input-wrapper"
                [ngClass]="inputClass"
                appearance="outline"
                [hideRequiredMarker]="true"
                floatLabel="always"
                [class.mat-form-field-invalid]="control?.invalid && control?.touched"
                [class.mb-1]="control?.invalid && control?.touched">
  <mat-label [hidden]="hideLabel">
    <span>{{inputLabel}}</span>
    <span *ngIf="isRequired" class="color-error">*</span>:
  </mat-label>
  <input *ngIf="!numeric; else numericInput" matInput
         [placeholder]="placeholder"
         [type]="inputType"
         [formControl]="control"
         class="app-input"
         data-lpignore="true"
         [maxlength]="maxLength"
         [required]="isRequired"
         [readonly]="readonly"
         [errorStateMatcher]="errorMatcher()"
         (blur)="blurChange.next($event)"
         [attr.data-test-id]="'input_'+testId">
  <ng-template #numericInput>
    <input matInput
           [placeholder]="placeholder"
           [type]="inputType"
           [formControl]="control"
           class="app-input"
           data-lpignore="true"
           [maxlength]="maxLength"
           appAutonumeric [options]="currencyControlOptions"
           [autonumericUpdateTriggerEventType]="autonumericUpdateTriggerEventType"
           [required]="isRequired"
           [readonly]="readonly"
           [errorStateMatcher]="errorMatcher()"
           (blur)="blurChange.next($event)"
           [attr.data-test-id]="'input_'+testId">
  </ng-template>
  <span *ngIf="inputType === 'search'"
        aria-hidden="true"
        class="icon icon-group color-gray-darker" matSuffix></span>
  <mat-hint *ngIf="inputHint && !isWarningVisible" class="hint" [ngClass]="inputHintClass">
    <span *ngIf="inputHintIcon" class="icon icon-info"></span> <span [innerHTML]="inputHint"></span></mat-hint>

  <mat-hint *ngIf="isWarningVisible" class="color-warning d-flex ai-center">
    <span class="icon icon-error icon-fs-md mr-q"></span>
    <span class="fs-sm">{{warningMessage}}</span>
  </mat-hint>

  <mat-hint #hints *ngIf="!isWarningVisible && !inputHint">
    <ng-content selector="mat-hint"></ng-content>
  </mat-hint>

  <mat-error *ngIf="shouldShowErrorMessage && control?.invalid && control?.touched">
    <span class="icon icon-error fs-md"></span> {{getErrorMessage()}}</mat-error>
  <ng-content></ng-content>
</mat-form-field>
